var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9357 7.52545C14.9357 7.52545 14.5402 12.4314 14.3108 14.498C14.2015 15.485 13.5918 16.0634 12.5931 16.0816C10.6927 16.1158 8.79 16.118 6.89027 16.0779C5.92947 16.0583 5.32997 15.4726 5.2229 14.5031C4.99198 12.4183 4.59863 7.52545 4.59863 7.52545",
    stroke: "#0869FB",
    strokeWidth: 1.09264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9445 5.17513H3.5918",
    stroke: "#0869FB",
    strokeWidth: 1.09264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5631 5.17283C12.9913 5.17283 12.4989 4.76855 12.3867 4.20839L12.2097 3.32263C12.1004 2.91398 11.7304 2.63135 11.3086 2.63135H8.22519C7.80343 2.63135 7.43339 2.91398 7.32412 3.32263L7.14711 4.20839C7.03494 4.76855 6.54252 5.17283 5.9707 5.17283",
    stroke: "#0869FB",
    strokeWidth: 1.09264,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlueIcon);
export default __webpack_public_path__ + "static/media/DeleteBlueIcon.d29fc2923a99c5c50351061ee1ff99a2.svg";
export { ForwardRef as ReactComponent };